import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  next();
});

new Vue({
  el: '#app',
  router,
  // directive,
  render: (h) => h(App),
});
